import { useHealth } from '@/hooks/use-health';
import { Card, CardHeading } from '@/components/ui/Card';

/** Live `/api/health` readout — proves the SPA can reach the api and the DB. */
export function HealthCard() {
  const { data, error, isPending, isFetching } = useHealth();

  return (
    <Card as="section">
      <CardHeading
        action={
          isFetching ? <span className="text-xs text-slate-400">refreshing…</span> : undefined
        }
      >
        API health
      </CardHeading>

      {isPending && <p className="mt-4 text-slate-500">Checking…</p>}

      {error && (
        <p className="mt-4 rounded-xl border border-red-200 bg-red-50 px-3.5 py-2.5 text-sm text-red-700">
          Could not reach the API — is it running on port 4000? ({error.message})
        </p>
      )}

      {data && (
        <>
          <div className="mt-4 flex items-center gap-3">
            <span
              className={`inline-block size-2.5 rounded-full ${
                data.db === 'connected' ? 'bg-safe-500' : 'bg-sun-400'
              }`}
            />
            <span className="text-sm text-slate-600">
              status <strong className="text-ink">{data.status}</strong> · db{' '}
              <strong className="text-ink">{data.db}</strong>
            </span>
          </div>
          <pre className="mt-4 overflow-x-auto rounded-xl bg-ink p-4 text-xs text-slate-100">
            {JSON.stringify(data, null, 2)}
          </pre>
        </>
      )}
    </Card>
  );
}
